<template>
</template>

<script>
import Cookies from 'js-cookie'
export default {
    name: 'Redirect',
    created() {
    //live server
       this.$router.replace("/shop/list?link=228ae5d16e3bc30a");
    //test server
      //  this.$router.replace("/shop/list?link=oXT4Ffe2I3m0HtN5");
       Cookies.set('redirect',true); 
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/Shop/containers/Redirect.vue